import React from 'react';

import { TabItem, Tabs } from 'src/components/common';

import { EmployerInitialBillingRules } from './EmployerInitialBillingRules';
import { VerifierInitialBillingRules } from './VerifierInitialBillingRules';

const tabs: Array<TabItem> = [
  {
    key: 'Verifier Billing Rules',
    label: 'Verifier Billing Rules',
    component: <VerifierInitialBillingRules />,
  },
  {
    key: 'Employer Billing Rules',
    label: 'Employer Billing Rules',
    component: <EmployerInitialBillingRules />,
  },
];

export const InitialBillingRulesCVAdmin: React.FC = () => {
  return <Tabs tabs={tabs} />;
};
